<!--
 * @Author: your name
 * @Date: 2021-03-12 13:35:58
 * @LastEditTime: 2021-08-06 13:56:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mooklook_phone\src\components\swiper.vue
-->
<template>
  <div class="container-swiper">
    <swiper
      :options="swiperOption"
      class="swiper-container swiper-pagination1"
      ref="mySwiper"
    >
      <!-- 添加的图片,src中存放图片路径 -->
      <swiper-slide v-for="(item, Index) in starItemList" :key="Index">
        <div class="swiper_item">
          <div class="item" @click="onStarItemPage(item)">
            <div class="img">
              <img class="auto-img" :src="item.imageUrl" />
            </div>
            <div class="name">{{ item.title }}</div>
            <div class="vice_name">{{ item.description }}</div>
            <div
              class="understand_now"
              :data-starId="item.id"
              :data-index="Index"
              :data-item="JSON.stringify(item)"
            >
              {{ lange == "Ch" ? "立即了解" : "すぐにわかる" }}
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <!-- <div
      class="swiper-button-prev layout_vertica_center web"
      slot="button-prev"
    >
      <i class="el-icon-arrow-left" style="font-weight: bold !important"></i>
    </div>
    <div
      class="swiper-button-next layout_vertica_center web"
      slot="button-next"
    >
      <i class="el-icon-arrow-right" style="font-weight: bold !important"></i>
    </div> -->
  </div>
</template>

<script>
//局部引入swiper插件
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
export default {
  name: "BestCarousel",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: ["starItemList"],
  // 定义属性
  data() {
    return {
      banner: [],
      swiperOption: {
        // 参数选项,显示小点
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },

        // 箭头配置
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        // },
        // spaceBetween: 10,
        // slidesPerView: 3,
        // slidesPerGroup: 3,
        //循环
        loop: true,
        //自动播放的相关设置
        autoplay: {
          disableOnInteraction: true,
          delay: 6000,
        },
        // slidesPerView: 3,
        on: {
          // click: (e) => {
          //   if (document.querySelectorAll(".understand_now")[e.clickedIndex]) {
          //     const id = document
          //       .querySelectorAll(".understand_now")
          //       [e.clickedIndex].getAttribute("data-starId");
          //     const item = document
          //       .querySelectorAll(".understand_now")
          //       [e.clickedIndex].getAttribute("data-item");
          //     const index = document
          //       .querySelectorAll(".understand_now")
          //       [e.clickedIndex].getAttribute("data-index");
          //     this.onStarItemPage(id, item, index);
          //   }
          // },
        },
      },
    };
  },
  computed: {},
  // 监控data中的数据变化
  watch: {
    starItemList(val) {
      if (val) {
        this.swiperOption.loop = val.length > 2 ? true : false;
      }
    },
  },
  // 方法集合
  methods: {
    onStarItemPage(item) {
      if(item.targetLink){
        window.location.href = item.targetLink
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>

<style lang='less' scoped>
.container-swiper {
  max-width: 1440px;
  min-width: 1240px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  .swiper-container {
    // calc(100% - 100px)
    width: 100%;
    margin: 0px auto;
    position: relative;
    /deep/.swiper {
      // &-slide {
      //   width: 440px !important;
      //   margin-right: 10px;
      // }
      // &-slide:nth-child(3n) {
      //   margin-right: 50px;
      // }


      &_item {
        display: flex;
        margin: 0 auto;
        .item {
          width: 100%;
          max-height: 509px;
          text-align: center;
          font-size: 20px;
          font-weight: 400;
          margin: 0 auto;
          .img {
            width: 100%;
            height: 100%;
            overflow: hidden;
            margin-bottom: 20px;
          }
          .name {
            color: #212121;
          }
          .vice_name {
            color: #878787;
            margin: 12px 0;
          }
          .understand_now {
            width: 200px;
            height: 64px;
            background: #faecc7;
            font-size: 18px;
            font-weight: 400;
            color: #876d4b;
            text-align: center;
            line-height: 64px;
            margin: 30px auto;
            cursor: pointer;
          }
        }
      }
    }
  }
  // .swiper-container:hover {
  //   .swiper-button-prev,
  //   .swiper-button-next {
  //     display: block;
  //   }
  // }
  // .swiper-slide a {
  //   display: block;
  // }

  .swiper-button {
    &-prev {
      left: 0px;
    }
    &-next {
      right: 0px;
    }
    &-prev,
    &-next {
      width: 36px;
      height: 36px;
      border: 2px solid #212121;
      border-radius: 50%;
      z-index: 1;
      cursor: pointer;
      text-align: center;
      line-height: 36px;
      font-size: 24px !important;

      color: #212121;
      // display: none;
    }
  }
}
</style>
